import { Reducer } from "redux";
import { PaymentsGatewayAction, PaymentsGatewayState } from "./types";

const initialState: PaymentsGatewayState = {
  status: "init"
};

const reducer: Reducer<PaymentsGatewayState, PaymentsGatewayAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "paymentsGateway/FETCH_INFO":
      if (state.status === "loaded") {
        return {
          ...state
          // No updates this information
          // status: "updating"
        };
      } else {
        return {
          status: "loading"
        };
      }
    case "paymentsGateway/FETCH_INFO_SUCCEEDED":
      return {
        status: "loaded",
        payload: action.paymentsGateway
      };
    case "paymentsGateway/FETCH_INFO_FAILED":
      return {
        status: "error",
        error: action.error
      };

    default:
      return state;
  }
};

export default reducer;
